import * as angular from 'angular';
import { SelectOption } from './select-field.component';

class SelectFieldMenuItemController {
  private value!: SelectOption['value'];
  private confirm!: SelectOption['confirm'];
  private onSelect!: ($args: { $value: SelectOption['value'] }) => void;

  public handleClick() {
    this.onSelect({ $value: this.value });
  }

  private handleConfirm() {
    this.onSelect({ $value: this.value });
  }
}

export const SelectFieldMenuItemComponent: angular.IComponentOptions = {
  controller: SelectFieldMenuItemController,
  controllerAs: 'ctrl',
  bindings: {
    confirm: '<',
    label: '<',
    labelCaption: '<',
    onSelect: '&',
    selected: '<',
    value: '<',
  },
  template: `
    <li class="menu-item menu-item--with-modal"
        ng-if="ctrl.confirm"
        ng-class="{ 'is-selected': ctrl.selected }">
      <span class="menu-item-indicator"></span>
      <span class="menu-item-label" ng-class="{ 'menu-item-label--captioned': ctrl.labelCaption}">
        <modal-dialog-link
          confirm-button-cancel="{{ ctrl.confirm.buttonCancel || 'Cancel' }}"
          confirm-button-confirm="{{ ctrl.confirm.buttonConfirm || 'Ok' }}"
          confirm-content="ctrl.confirm.content"
          confirm-title="ctrl.confirm.title"
          modal-theme="{{ ctrl.confirm.modalTheme }}"
          modal-type="{{ ctrl.confirm.modalType }}"
          on-confirm="ctrl.handleConfirm()"
        >
          <span class="menu-item-label__title">{{ctrl.label}}</span>
          <span ng-if="ctrl.labelCaption"
                class="menu-item-label__caption">
            {{ctrl.labelCaption}}
          </span>
        </modal-dialog-link>
      </span>
    </li>

    <li class="menu-item"
        ng-if="!ctrl.confirm"
        ng-class="{ 'is-selected': ctrl.selected }"
        ng-click="ctrl.handleClick()">
      <span class="menu-item-indicator"></span>
      <span class="menu-item-label" ng-class="{ 'menu-item-label--captioned': ctrl.labelCaption }">
        <span class="menu-item-label__title">{{ctrl.label}}</span>
        <span ng-if="ctrl.labelCaption"
              class="menu-item-label__caption">
          {{ctrl.labelCaption}}
        </span>
      </span>
    </li>
  `,
};
